import Cookies from 'js-cookie';

export const revertToRegularPrice = () => {
    const siteBody = document.body;
    if (!siteBody) {
        return false;
    }

    const active_subscriber =
        parseInt(siteBody.getAttribute('data-active-subscriber')) || 0;
    if (active_subscriber) {
        return false;
    }

    const membership_in_cart =
        parseInt(siteBody.getAttribute('data-membership-in-cart')) || 0;
    if (membership_in_cart) {
        return false;
    }

    const showMembershipPrice =
        parseInt(siteBody.getAttribute('data-show-member-pricing')) || 0;
    if (!showMembershipPrice) {
        return true;
    }

    return Boolean(parseInt(Cookies.get('add_membership_product'))) === false;
};

export const membershipWidgetInit = () => {
    const inputs = Array.prototype.slice.apply(document.querySelectorAll('[data-member-widget-input]'));
    if (!inputs) {
        return;
    }

    if (!inputs.length) {
        return;
    }

    inputs.forEach((input) => {
        input.addEventListener('change', (event) => {
            const { target } = event;
            if (!target) {
                return;
            }

            inputs.forEach((input) => {
                input.checked = Boolean(target.checked);

                if (target.checked) {
                    input.setAttribute('checked', 'checked');
                } else {
                    input.removeAttribute('checked');
                }
            });

            const tabs = Array.prototype.slice.apply(document.querySelectorAll('[data-member-price-tab]'));

            tabs.forEach((tab) => {
                tab.classList.remove('product-form__price--selected');
            });

            switch (Boolean(target.checked)) {
                case true:
                    {
                        tabs.forEach((tab) => {
                            Cookies.set('add_membership_product', 1);

                            const type = tab.dataset.memberPriceTab;
                            if (!type) {
                                return;
                            }

                            if (type !== 'membership') {
                                return;
                            }

                            tab.classList.add('product-form__price--selected');
                        });
                    }
                    break;
                case false: {
                    Cookies.set('add_membership_product', 0);

                    // eslint-disable-next-line no-undef
                    document.dispatchEvent(new CustomEvent('minicart:membership:remove', {
                            detail: {}
                        }));

                    tabs.forEach((tab) => {
                        const type = tab.dataset.memberPriceTab;
                        if (!type) {
                            return;
                        }

                        if (type !== 'regular') {
                            return;
                        }

                        tab.classList.add('product-form__price--selected');
                    });
                }
            }
        });
    });

    if (!revertToRegularPrice()) {
        inputs.forEach((input) => {
            input.checked = true;
            input.setAttribute('checked', 'checked');
        });

        const tabs = Array.prototype.slice.apply(document.querySelectorAll('[data-member-price-tab]'));
        if (!tabs) {
            return;
        }

        if (!tabs.length) {
            return;
        }

        tabs.forEach((tab) => {
            tab.classList.remove('product-form__price--selected');
        });

        tabs.forEach((tab) => {
            const type = tab.dataset.memberPriceTab;
            if (!type) {
                return;
            }

            if (type !== 'membership') {
                return;
            }

            tab.classList.add('product-form__price--selected');
        });

        return;
    }

    const addMembershipProduct =
        Boolean(parseInt(Cookies.get('add_membership_product'))) !== false;

    inputs.forEach((input) => {
        input.checked = Boolean(addMembershipProduct);

        if (addMembershipProduct) {
            input.setAttribute('checked', 'checked');
        } else {
            input.removeAttribute('checked');
        }
    });

    const tabs = Array.prototype.slice.apply(document.querySelectorAll('[data-member-price-tab]'));
    if (!tabs) {
        return;
    }

    if (!tabs.length) {
        return;
    }

    tabs.forEach((tab) => {
        tab.classList.remove('product-form__price--selected');
    });

    switch (Boolean(addMembershipProduct)) {
        case true:
            {
                tabs.forEach((tab) => {
                    const type = tab.dataset.memberPriceTab;
                    if (!type) {
                        return;
                    }

                    if (type !== 'membership') {
                        return;
                    }

                    tab.classList.add('product-form__price--selected');
                });
            }
            break;
        case false: {
            tabs.forEach((tab) => {
                const type = tab.dataset.memberPriceTab;
                if (!type) {
                    return;
                }

                if (type !== 'regular') {
                    return;
                }

                tab.classList.add('product-form__price--selected');
            });
        }
    }
};

export default {
    membershipWidgetInit
};
